import { Reducer } from 'redux';
import { Route } from '../router';

export class ModuleBase {
  private readonly routes?: Route[];
  private readonly reducers?: Record<string, Reducer>;

  constructor({ routes, reducers }: { routes?: Route[]; reducers?: Record<string, Reducer> }) {
    this.routes = routes;
    this.reducers = reducers;
  }

  public getRoutes() {
    return this.routes;
  }

  public getReducers() {
    return this.reducers;
  }
}
